export enum Role {
  ROLE_AGRISED_ADMIN = 'auth_roles_agrised_admin',
  ROLE_AGRISED_USER = 'auth_roles_agrised_user',
  ROLE_AGRISED_ADMIN_SUPER = 'auth_roles_agrised_admin_super',
}

export type RoleKey = keyof typeof Role;

export const ROLE_KEYS = new Map(Object.entries(Role).map(([value, key]) => [key, value])) as Map<Role, RoleKey>;
